import { prop } from 'ramda';

import { DocumentType } from '../../../types/document';
import { toImageFromProp } from '../fields/image';
import { toLinkFromProp } from '../fields/link';
import { toRichTextFromProp, toTextFromProp } from '../fields/text';
import { documentEntity } from './internal';

const processRewardedInnovation = (data) => ({
  type: DocumentType.REWARDED_INNOVATION,
  image: toImageFromProp('image', data),
  link: toLinkFromProp('link', data),
  sheet: toRichTextFromProp('sheet', data),
  mainTitle: toTextFromProp('main_title', data),
  mainDescription: toRichTextFromProp('main_description', data),
});

export const RewardedInnovation = documentEntity(
  DocumentType.REWARDED_INNOVATION,
  {
    processStrategy: (entity) =>
      processRewardedInnovation(prop('data', entity)),
  }
);
